import Locations     from "./elements/consumer/locations";
import Location      from "./elements/consumer/location";
import Services      from "./elements/consumer/services";
import Resources     from "./elements/consumer/resources";
import Appointments  from "./elements/consumer/appointments";
import Appointment   from "./elements/consumer/appointment";
import Availability  from "./elements/consumer/availability";
import LocationSetup from "./elements/setup/locationSetup";
import ResourceSetup from "./elements/setup/resourceSetup";
import ServiceSetup  from "./elements/setup/serviceSetup";
import Calendar      from "./elements/setup/calendar";


export const OnSchedElements = {
  location:      Location,
  locations:     Locations,
  services:      Services,
  resources:     Resources,
  appointments:  Appointments,
  appointment:   Appointment,
  availability:  Availability,
  locationSetup: LocationSetup,
  resourceSetup: ResourceSetup,
  serviceSetup:  ServiceSetup,
  calendar:      Calendar,
}
